import React, { memo, useEffect, useState } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useFormValidation } from '../../../hooks/useFormValidation'
import {
    flagActions,
    initEmptyData,
} from '../../../store/actions/modelsActions/control'
import { buildControlsExt, checkboxInput } from '../../inputs/controls'
import { PATH_JOINER } from '../utils/getConfigBitPath'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectConfigBit } from '../../../store/selectors/configSelectors'
import { getLabel } from '../../../utils/getLabel'

interface IFlagProps {
    dataPath: string
    dataSchema: any
    name: string
    wrapper?: string
    isViewOnly?: boolean
}

export const Flag = memo(function Flag({
    dataPath,
    dataSchema = {},
    name,
    wrapper,
    isViewOnly,
}: IFlagProps) {
    const {
        description,
        is_nullable: isNullable,
        name: inputLabel,
        default: defaultValue,
        change_warning: changeWarning,
    } = dataSchema

    const dispatch = useAppDispatch()
    const configBit = useAppSelector(selectConfigBit(dataPath.split(PATH_JOINER)))
    const [inputState, setInputState, touched] = useFormValidation(configBit || {}, {})
    const [isChanged, setIsChanged] = useState(inputState?.[name])
    const label: string = getLabel(name,inputLabel)
    const path = [...(dataPath.split(PATH_JOINER) || []), name]

    const controlDescriptors = [
        checkboxInput(
            name,
            description,
            label,
            '',
            isViewOnly,
            '',
            isNullable,
            defaultValue,
            changeWarning,
        ),
    ]

    const FlagInput = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched,
    )

    useEffect(() => {
        if (dataPath?.length) {
            if (
                !configBit ||
                !Object.keys(configBit).length ||
                typeof configBit?.[name] === 'undefined'
            ) {
                dispatch(initEmptyData({ schema: dataSchema, name, path }))
            }
        }
    }, []) // eslint-disable-line

    useEffect(() => {
        if (configBit && dataPath?.length) {
            setInputState(configBit)
        }
    }, [configBit]) // eslint-disable-line

    useEffect(() => {
        if (isChanged !== inputState?.[name] && dataPath?.length) {
            setIsChanged(inputState?.[name])
            dispatch(flagActions.modify(inputState?.[name], path, configBit))
        }
    }, [inputState]) // eslint-disable-line

    return <div className={`${!wrapper ? 'w-100' : ''}`}>{FlagInput}</div>
})
